import AbstractService from "./abstract.service"
import PaymentSourceTransformer, { baseUri } from "@/transformers/paymentSource.transformer"

class PaymentSourceService extends AbstractService {
  constructor() {
    super({ baseUri, transformer: PaymentSourceTransformer })
  }

  getPaymentSourceIntent(uuid) {
    return this.get(`${this.baseUri}/intent/${uuid}`, {
      needsAuth: true,
      transformer: this.transformer
    })
  }

  /**
   * Polls the server to get the updated version of the payment source for a maximum of 5 seconds,
   * uses the created field to determine the last version.
   *
   * @param {string} uuid
   * @param {number} created The created field of the previous payment source
   * @param {function('success' | 'pending' | 'failed', object | undefined )} cb
   *
   * @returns {Promise<void>}
   */

  async pollForUpdatedPaymentSource(uuid, created, cb) {
    let count = 0
    const interval = setInterval(async () => {
      try {
        const paymentSource = await this.getItem(uuid)
        if (paymentSource.cardInfo?.created > created) {
          clearInterval(interval)
          cb("success", paymentSource)
        } else if (count === 5) {
          clearInterval(interval)
          cb("pending", {})
        }
      } catch (error) {
        clearInterval(interval)
        cb("failed", {})
      }
      count++
    }, 1000)
  }
}

const paymentSourceService = new PaymentSourceService()
export default paymentSourceService
